import { Outlet } from "react-router-dom";
import { Box, Container, Flex, Text, VStack } from "@chakra-ui/react";
import ColorModeToggle from "../../../shared/layout/ColorModeToggle";
import { BrandLogo } from "../../../shared/ui";

// Aceita `children` (usado por rotas fora do prefixo /auth, como /reset-password e
// /verify-email) ou renderiza <Outlet/> quando usado como layout de rotas aninhadas
// (children do array de rotas /auth no router).
export default function AuthLayout({ children }) {
  return (
    <Flex minH="100vh" bg="app-page" align="center" justify="center" p={4}>
      <ColorModeToggle position="absolute" top={3} right={3} />
      <Container maxW="440px" p={0}>
        <VStack spacing={2} mb={6}>
          <BrandLogo h="40px" />
          <Text color="app-muted-fg" fontSize="sm">
            Gestão financeira do plantonista PJ
          </Text>
        </VStack>
        <Box bg="app-card" border="1px solid" borderColor="app-border" borderRadius="xl" boxShadow="sm" p={{ base: 6, md: 8 }}>
          {children ?? <Outlet />}
        </Box>
      </Container>
    </Flex>
  );
}
